import "./Locations.css";
import Splitter from "../../components/Splitter/Splitter.jsx";
import Location1 from "../../assets/images/Locations/location1.avif";
import Location2 from "../../assets/images/Locations/location2.avif";
import Location3 from "../../assets/images/Locations/location3.avif";
import Text from "../../components/Text/Text.jsx";

function Locations() {
  return (
    <div className="locations-container">
      <Splitter
        image={Location1}
        children={
          <>
            <Text
              preheader={"Eine Kulisse, die euch den Atem raubt"}
              title={"Hochzeitsmenü unter freiem Himmel"}
              body={
                "Inmitten sanfter Weinberge gelegen, bietet die Villa Sonnenhang den perfekten Rahmen für eine elegante Sommerhochzeit. Ob Empfang auf der Terrasse oder Dinner unter Lichterketten im Garten – hier verbindet sich mediterraner Charme mit stilvollem Ambiente."
              }
            />
            <Text
              body="Wir begleiten euer Fest mit einem maßgeschneiderten Hochzeitsmenü oder
          Buffet, das eure Geschichte kulinarisch widerspiegelt. Unsere Küche
          passt sich flexibel euren Wünschen an – von regionalen Klassikern bis
          zu internationalen Highlights."
            />
          </>
        }
        hasButton
        buttonText="Kontakt aufnehmen"
        nav="/kontakt"
      />

      <Splitter
        image={Location2}
        children={
          <Text
            preheader="Wo Geschichte und Liebe sich begegnen"
            title="Rustikaler Charme trifft modernes Catering"
            body="Wer es urig und dennoch hochwertig mag, wird den Gutshof Falkenried
          lieben. Die historische Scheune mit offenem Dachstuhl schafft eine
          warme, festliche Atmosphäre – ideal für ausgelassene Feiern mit bis zu
          120 Gästen."
          />
        }
        hasButton
        buttonText="Kontakt aufnehmen"
        nav="/kontakt"
        reverse
      />

      <Splitter
        image={Location3}
        children={
          <>
            <Text
              preheader="Euer Tag. Euer Stil. Eure Stadt."
              title="Urban. Stilvoll. Einzigartig."
              body="Mitten in der Stadt und trotzdem mit Blick aufs Wasser – das Loft am
          Hafen ist eine moderne Eventlocation mit industriellem Chic. Die
          großzügigen, lichtdurchfluteten Räume eignen sich perfekt für
          stilvolle Hochzeiten in urbanem Flair."
            />
            <Text
              body="Ob gesetztes Dinner oder lockeres Flying Buffet: Wir sorgen dafür,
          dass eure Gäste kulinarisch genauso beeindruckt sind wie vom Ausblick
          auf den Hafen."
            />
          </>
        }
        hasButton
        buttonText="Kontakt aufnehmen"
        nav="/kontakt"
      />
    </div>
  );
}

export default Locations;
